/* eslint-disable camelcase */
define('ShippingRestrictions.Review.View', [
  'Wizard.Module',
  'ShippingRestrictions.Helper',
  'uc_shipping_restrictions_review_module.tpl',
  'SC.Configuration',
  'jQuery'
], function (
  WizardModule,
  ShippingRestrictionsHelper,
  template,
  Configuration,
  jQuery
) {
  'use strict';

  var CONFIG_KEY = 'shippingRestrictions';

  function getConfig() {
    var config = Configuration && typeof Configuration.get === 'function' ? Configuration.get(CONFIG_KEY) : null;

    return config || {};
  }

  return WizardModule.extend({

    template: template,

    className: 'UnlockCommerce.ShippingRestrictions.Review.View',

    errors: ['ERR_UC_SHIPPING_RESTRICTION'],

    initialize: function initialize(options) {
      this.wizard = options.wizard;
      this.step = options.step;
      this.model = options.wizard.model;
      this.module_id = options.module_id || (this.template ? this.template.Name : '');
    },

    getSelectedAddress: function getSelectedAddress() {
      var addressId = this.model.get('shipaddress');
      var addresses = this.model.get('addresses');
      var address = addressId && addresses ? addresses.get(addressId) : null;

      if (!address) {
        return null;
      }

      return {
        state: address.get('state'),
        country: address.get('country')
      };
    },

    submit: function submit() {
      return this.isValid();
    },

    isValid: function isValid() {
      var config = getConfig();
      var violations;

      if (config.enabled === false) {
        return jQuery.Deferred().resolve();
      }

      violations = ShippingRestrictionsHelper.evaluate({
        lines: this.model.get('lines'),
        address: this.getSelectedAddress(),
        shipMethodId: this.model.get('shipmethod'),
        airShipMethodIds: ShippingRestrictionsHelper.parseAirShipMethodIds(config.airShipMethodIds)
      });

      if (!violations.length) {
        return jQuery.Deferred().resolve();
      }

      return jQuery.Deferred().reject({
        errorCode: 'ERR_UC_SHIPPING_RESTRICTION',
        errorMessage: ShippingRestrictionsHelper.buildErrorMessage(violations)
      });
    },

    getContext: function getContext() {
      return {};
    }
  });
});
